import { call, put, takeLatest } from 'redux-saga/effects';
import { base_url, endpoints } from '../../../constants';
import { AxiosService } from '../../../services';
import { actionTypes } from '../../../types';
import {
    updateUserInfoSuccess,
    updateUserInfoFailure,
} from '../../actions/authActions/updateUserInfoActions';

function* updateUserInfo({ payload, callback }) {
    try {
        const response = yield call(AxiosService, {
            method: 'post',
            base_url: base_url,
            endPoint: endpoints.updateUserInfo,
            payload: payload,
            isAuth: true,
        });
        yield put(
            updateUserInfoSuccess({
                status: response?.data?.status,
                response: response?.data?.response,
                message: response?.data?.message,
            })
        );
        if (callback && response?.data?.status === 200) {
            callback(response.data.response, response?.data?.status);
        } else if (callback) {
            callback(response.data.message, response?.data?.status);
        }
    } catch (error) {
        console.log('UPDATE_USER_INFO_FAILURE:', error?.response?.data);
        yield put(
            updateUserInfoFailure({
                status: error?.response?.data?.status,
                response: {},
                message: error?.response?.data?.message,
            })
        );
    }
}

function* updateUserInfoSaga() {
    yield takeLatest(actionTypes.UPDATE_USER_INFO_REQUEST, updateUserInfo);
}

export default updateUserInfoSaga;
